module.exports = __webpack_public_path__ + "media/pauze.8c555e30.mp3";